export default "__VITE_ASSET__903ef26e__"